import { useTranslation } from 'react-i18next';

export function TypingIndicator() {
  const { t } = useTranslation('adminAssistant');

  return (
    <p
      className="bubble-in flex items-center gap-2 px-1 text-xs text-muted-foreground"
      aria-live="polite"
    >
      <span className="flex items-center gap-1" aria-hidden="true">
        <span className="typing-dot h-1.5 w-1.5 rounded-full bg-primary" />
        <span className="typing-dot h-1.5 w-1.5 rounded-full bg-primary" />
        <span className="typing-dot h-1.5 w-1.5 rounded-full bg-primary" />
      </span>
      {t('message.typing')}
    </p>
  );
}
